import script from "./IniciarSesion.vue?vue&type=script&setup=true&lang=js"
export * from "./IniciarSesion.vue?vue&type=script&setup=true&lang=js"

import "./IniciarSesion.vue?vue&type=style&index=0&id=c8e061e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e061e8"]])

export default __exports__